<!-- Filter Panel -->
<div class="col-lg-12 nopadding">
    <app-filter-panel [pageName]="pageName" [GridColumns]="filterPanelGridColumns" [DefaultFilterArray]="defaultFilterArray" [isOpenFilterDialog]="isOpenDialog" 
        (FilterEvent)="filterApplyFilterEvent($event)" (FetchUpdatedDefaultFilters)="fetchRequestedFilter($event)">
    </app-filter-panel>
</div>

<div class="col-md-12 nopadding">
    <p-tabs class="finra-inquiry-tab" value="0">
        <p-tablist>
            <p-tab value="0" (click)="clickFinraInquiryTab('Reg-Inquiry-List')">Upgraded Inquiries</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <app-finra-reg-inquiry-list [defaultFilters]="RegInquiryDefaultFilterArray" (editInquiryDetail)="editInquiryDetail($event);" (reloadScreen)="refreshScreen($event);"></app-finra-reg-inquiry-list>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>